import React from 'react'

import { useGoogleLogin } from '@react-oauth/google'
import { IMG } from '../../themes'

import { StyleGoogle } from './style'
import { LOG_IN } from '../../helpers'

const ButtonGoogleLogin = ({ onSuccess }) => {
  const googleSignIn = useGoogleLogin({
    onSuccess
  })

  return (
    <StyleGoogle>
      <div className='google-button' onClick={googleSignIn}>
        <div className='google-icon-wrapper'>
          <img
            className='google-icon'
            src={IMG['google-logo.svg']}
            alt='google-logo'
          />
        </div>
        <p className='button-text'><b>{LOG_IN.LOGIN_GOOGLE['EN']}</b></p>
      </div>
    </StyleGoogle>
  )
}

export default ButtonGoogleLogin
